import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';

@Component({
    selector: 'field-sequential-header',
    templateUrl: './field-sequential-header.component.html',
    standalone: true,
    imports: [ AfTranslateDirective]
})
export class FieldSequentialHeaderComponent implements OnChanges {
  fieldSequentialHeader: any = {
    titleField: ''
  }

  constructor() { }

  @Input() field: any = null;

  ngOnChanges(): void {
    if(this.field) {
      this.fieldSequentialHeader.titleField = this.field.extendedLabel && this.field.extendedLabel !== ''? this.field.extendedLabel : this.field.label;
      if(this.field.fieldTypeId === 'money'){
        this.fieldSequentialHeader.titleField += ' ('+ this.field.currencySymbol +')'
      }
    }
  }
}
